import { render } from "./SocialSecurity.vue?vue&type=template&id=aa662cd2"
import script from "./SocialSecurity.vue?vue&type=script&lang=js"
export * from "./SocialSecurity.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__